/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import Swiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { Icon } from '../../../ui/Icon';

import * as styles from './index.styles';

import RatingStar from '../RatingStar';
export default class Slider extends SafePureComponent {
  swiper = node => (this.swiper = node && node.swiper);
  mySwiper = React.createRef();
  state = { isBeginning: true, isEnd: false };

  constructor(props) {
    super(props);

    this.goPrev = this.goPrev.bind(this);
    this.goNext = this.goNext.bind(this);
    this.onSlideChange = this.onSlideChange.bind(this);
  }

  renderCards() {
    const { reviews } = this.props;

    return reviews.map((review, index) => {
      const { first_name, last_name } = review.reviewer;
      return (
        <div key={index}>
          <div className="boxsec">
            <div className="rating">
              <RatingStar maxStar="5" rating={review.rating} />
            </div>

            <div className="reviewer-info">
              {first_name} {last_name}
            </div>
            <p className="comment">{review.comments}</p>
            <div className="timeago">{review.timeago}</div>
          </div>
        </div>
      );
    });
  }

  goPrev = () => {
    if (this.mySwiper.current.swiper) {
      this.mySwiper.current.swiper.slidePrev();
    }
  };

  goNext = () => {
    if (this.mySwiper.current.swiper) {
      this.mySwiper.current.swiper.slideNext();
    }
  };

  onSlideChange = param => {
    if (this.mySwiper.current.swiper) {
      this.setState({
        isBeginning: this.mySwiper.current.swiper.isBeginning,
        isEnd: this.mySwiper.current.swiper.isEnd,
      });
    }
  };

  renderNextPrevBtn = () => {
    const { isBeginning, isEnd } = this.state;

    return (
      <React.Fragment>
        {!isBeginning && (
          <button className="regus-button-prev" onClick={this.goPrev}>
            <Icon name="arrow-left" />
          </button>
        )}

        {!isEnd && (
          <button className="regus-button-next" onClick={this.goNext}>
            <Icon name="arrow-right" />
          </button>
        )}
      </React.Fragment>
    );
  };

  safeRender() {
    // {/* <div css={styles.homepageSlide}> */}
    const { reviews } = this.props;
    const swiperParams = {
      loop: false,
      spaceBetween: 30,
      slidesPerView: 4,
      autoplay: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (swiper, current) {
          let slidesPerView = 4;
          if (window.innerWidth < 1024) {
            slidesPerView = swiper.passedParams.breakpoints[1024].slidesPerView;
          }
          if (window.innerWidth < 768) {
            slidesPerView = swiper.passedParams.breakpoints[768].slidesPerView;
          }
          if (window.innerWidth < 480) {
            slidesPerView = swiper.passedParams.breakpoints[480].slidesPerView;
          }
          if (window.innerWidth < 320) {
            slidesPerView = swiper.passedParams.breakpoints[320].slidesPerView;
          }

          let total = reviews.length;
          var htmlCont = '';
          if (total > slidesPerView) {
            for (var i = 1; i <= total; i++) {
              let newCurrent = current + slidesPerView;
              let isActive =
                (i >= current && i < newCurrent) ||
                (newCurrent >= total && i < newCurrent - total)
                  ? 'swiper-pagination-bullet-active'
                  : '';

              htmlCont += `<span class="swiper-pagination-bullet ${isActive}"></span>`;
            }
          }
          return htmlCont;
        },
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      on: {
        slideChange: this.onSlideChange,
        touchEnd: this.onSlideChange,
      },
    };

    return (
      <React.Fragment>
        <div css={[styles.homepageSlide]}>
          <div className="shadowslide"></div>
          <Swiper ref={this.mySwiper} {...swiperParams}>
            {this.renderCards()}
          </Swiper>
          <div className="hiddenseperator"></div>

          {this.renderNextPrevBtn()}

          <div className="swiper-pagination"></div>
        </div>
      </React.Fragment>
    );
  }
}
